import { all } from 'redux-saga/effects';

import accountProfileSaga from './accountProfile/accountProfileSaga';
import accountActivationSaga from './AccountActivation/account-activation-saga';

export default function* rootSaga() {
  yield all([
    accountProfileSaga(),
    accountActivationSaga(),
  ]);
}



// WEBPACK FOOTER //
// ./src/features/Account/accountSaga.js